import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Truck, BadgeCheck, MapPin, Map } from "lucide-react";

const ITEMS = [
  { key: "removalists", label: "Removalists on MoveTender", icon: Truck },
  { key: "verified_removalists", label: "Verified removalists", icon: BadgeCheck },
  { key: "service_areas", label: "Service areas covered", icon: MapPin },
  { key: "states_covered", label: "States & territories", icon: Map },
];

export function LiveStats() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    api.get("/stats/public").then(({ data }) => setStats(data)).catch(() => setStats(null));
  }, []);
  if (!stats) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16" data-testid="live-stats-strip">
      <div className="rounded-2xl bg-asphalt text-white grid grid-cols-2 lg:grid-cols-4 divide-white/10 lg:divide-x overflow-hidden">
        {ITEMS.map(({ key, label, icon: Icon }, i) => (
          <div key={key} className="p-5 sm:p-7 flex items-center gap-4 animate-fade-up" style={{ animationDelay: `${i * 80}ms` }}>
            <div className="h-11 w-11 rounded-xl bg-kinetic/15 flex items-center justify-center shrink-0"><Icon className="h-5 w-5 text-kinetic" /></div>
            <div className="min-w-0">
              <p className="text-2xl sm:text-3xl font-extrabold leading-none" style={{ fontFamily: "'Montserrat', sans-serif" }} data-testid={`stat-${key}`}>{stats[key]}</p>
              <p className="text-xs sm:text-sm text-white/60 mt-1">{label}</p>
            </div>
          </div>
        ))}
      </div>
      <p className="mt-2 text-[11px] font-mono uppercase tracking-wider text-muted-foreground flex items-center gap-1.5"><span className="h-1.5 w-1.5 rounded-full bg-emerald-500 animate-pulse" /> Live from the MoveTender network</p>
    </section>
  );
}
